import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import style from './labeled-info-list.module.less';

export const LabeledInfoList = ({ children, className = '' }) => {
  return <dl className={classnames(className, style['labeled-info-list'])}>{children}</dl>;
};

LabeledInfoList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  className: PropTypes.string,
};
